export default {
    "/": {
        "title": "Taoify - ສະຖານີສ້າງເວັບສຳລັບການຄ້າຕອນກົດແຜນ | ສິນຄົນຈີນ, ເຂົ້າໃນທຸກປະເທດ",
        "desc": "Taoify ສ້າງເວັບ, ແປພາສາ, ຕື່ມສິນຄ້າ, ລົງການ, ການຮັບເງິນ, ແລະການຕິດຕໍ່ລູກຄ້າໃນຫຼັກການດຽວ: 18 ຄົນພະນັກງານ AI ຊີ້ນຊີ້ນເຮັດວຽກ, ການເປີດຮ້ານໃນ 20 ພາສາ, ສິນຄົນຈີນຂາຍໄດ້ທຸກປະເທດ."
    },
    "/feature": {
        "title": "ຟັງຊັນ · ຂໍ້ຕ່າງໆທີ່ຕ້ອງການເພື່ອເປີດຮ້ານ, ມີທັງໝົດໃນໜ້ານີ້ · Taoify",
        "desc": "ສ້າງເວັບ, ແປພາສາ, ຕື່ມສິນຄ້າ, ລົງການ, ການຮັບເງິນ, ແລະການດຶງລູກຄ້າ — Taoify ສ້າງ 15 ບົດການທີ່ຕ້ອງການສຳລັບການຂາຍຕອນກົດແຜນໃນຫຼັກການດຽວ, ບໍ່ຕ້ອງໄປຊອກຫາເຄື່ອງມືອື່ນອີກ."
    },
    "/ai-staff": {
        "title": "ພະນັກງານ AI · 18 ຄົນພະນັກງານ AI, ທີ່ເຮັດວຽກຫຼາຍທີ່ສຸດແມ່ນກົງການດຶງຜູ້ເຂົ້າເວັບ · Taoify",
        "desc": "ໃນ 18 ຄົນພະນັກງານ AI, 5 ຄົນໃນກຸ່ມການເພີ່ມການເຂົ້າເວັບມີບົດການພິເສດ: 12 ວິທີການກວດສິນຄ້າ, ການຕັດສິນ 30 ວັນ, ການປ່ຽນສິນຄ້າດຽວເປັນສິນຄ້າສຳລັບ 9 ກຸ່ມຜູ້ຊີ້ນຊີ້ນ, ແລະການສົ່ງອີເມວການເພີ່ມການເຂົ້າເວັບອັດຕາດີ."
    },
    "/logistics": {
        "title": "ການສົ່ງສິນຄ້າຕອນກົດແຜນ · ຈາກມືທີ່ຂອງທ່ານໄປຫາມືທີ່ຂອງລູກຄ້າ · Taoify",
        "desc": "ການສົ່ງເສັ້ນທາງ, ການຜ່ານການກວດ, ການສົ່ງເສັ້ນທາງຫຼັກ, ແລະການສົ່ງເສັ້ນທາງທີ່ສຸດ. ການເຊື່ອມຕໍ່ກັບ Yuntu, Yanwen, 4PX, ແລະການຈັດການບົດລາຍ, ການຕິດຕໍ່, ແລະການປຶກສາການເກີດບັນຫາທັງໝົດໃນຫຼັກການດຽວ."
    },
    "/payment": {
        "title": "ການຮັບເງິນ ແລະການຈ່າຍ · ລູກຄ້າສະເໝີວິທີການຈ່າຍທີ່ດ້ານໃດກໍ່ໄດ້ · Taoify",
        "desc": "ການເຊື່ອມຕໍ່ກັບ PayPal, Stripe, ປະກັນเครดິດ, ແລະ Alipay. ຮັບເງິນຕ່າງປະເທດ, ການถอนເງິນ RMB, ການຈ່າຍ T+7, ແລະການເຊື່ອມຕໍ່ກັບອັດຕາການຈ່າຍ ແລະ ວັນທີການເຂົ້າເງິນທີ່ແນະນຳຢູ່ໃນເວັບໄຊຕ໌."
    },
    "/pricing": {
        "title": "ລາຄາ · ລຳດັບການສະໝັກ + ການຈ່າຍຄ່າຫັກຕາມການຂາຍ · Taoify",
        "desc": "ການຈ່າຍຕາມລຳດັບການສະໝັກ: ບັນດານ $15/ເດືອນ, ທິດສະດີ $29/ເດືອນ, ຕົວແທນ $59/ເດືອນ, ການຈ່າຍຕາມປີ ຫຼື ປີກໍ່ເສັ້ນ. ການຈ່າຍຄ່າຫັກຕາມການຂາຍຕາມເດືອນ, ອັດຕາຕ່ຳສຸດ 3%."
    },
    "/cases": {
        "title": "ກ່າວປະຫວັດຜູ້ຂາຍ · ພວກເຂົາກຳລັງເຮັດສິ່ງທີ່ເຊື່ອມຕໍ່ກັນ · Taoify",
        "desc": "ສິນຄ້າຈີນຈາກອີຫຼູ, ຊີນເຊັນ 3C, ສິນຄ້າກາບຈາກກວາງໂຈວ, ແລະຜູ້ຂາຍຈາກເຢຍລະມັນ, ອາເມລິກາ, ເຝຣັ່ງ — ຕົວແທນຫົກຄົນ, ຄົນເລີ່ມຕົ້ນຕ່າງກັນ, ແຕ່ມີວິທີການດຽວ."
    },
    "/sign-up": {
        "title": "ການເປີດໃຊ້ບັນຊີຮ້ານຄົນດຽວ - Taoify ການລົງທະບຽນບັນຊີດ້ວຍບໍ່ເສຍຄ່າ",
        "desc": "ສ້າງເວັບໄຊຕ໌ຂອງຍຸ່ງເພີ່ມໃນ 10 ນາທີ, ບໍ່ຕ້ອງການລະບົບລະຫັດ, ການທົດລອງການນຳໃຊ້ທັງໝົດ, ການປະສົມປະສານທັງໝົດ. ລົງທະບຽນກັບ Taoify ໃນທີ່ນີ້, ເລີ່ມຕົ້ນການຂາຍສິນຄ້າຕອນກາງ."
    },
    "/for-china-sellers": {
        "title": "ສຳລັບຜູ້ຂາຍຈີນ: ຖ້າເຈົ້າເລືອກສິນຄ້າແລະກຳລັງຕັ້ງລາຄາ, ຂອງເຮົາຈະເຮັດສິ່ງອື່ນ. · Taoify",
        "desc": "ການສ້າງເວັບໄຊຕ໌, ການແປພາສາ, ການນຳເງິນ, ການພິມບັດ, ການຕອບກັບລູກຄ້າ — ການຂາຍສິນຄ້າຕອນກາງ, ມັນຈະຖືກເຮັດໂດຍເພື່ອນ. ການນຳເງິນ + ການນຳເງິນຕາຕ່າງ (ຕໍ່ຕັ້ງ 3%)."
    },
    "/for-global-sellers": {
        "title": "ສຳລັບຜູ້ຂາຍຕອນກາງ: ລົງທະບຽນສິນຄ້າຈາກຕັ້ງສິນຄ້າໃນຈີນ, ແລະຂາຍໃນຮ້ານຂອງເຈົ້າ · Taoify",
        "desc": "ບໍ່ຕ້ອງການກັບສິນຄ້າ, ບໍ່ຕ້ອງການກັບສິນຄ້າ: ລົງທະບຽນສິນຄ້າຈາກສາຍການຜະລິດຂອງຈີນ, ຜູ້ຊື້ຈະນຳເສັ້ນທາງຈາກສາງໃນຈີນ, ແລະເຈົ້າຈະໄດ້ຮັບການແຕກ. BuyLink ທີ່ຍັງສາມາດປ່ຽນລີ້ງ 1688, Taobao ເປັນສິນຄ້າຂອງເຈົ້າ."
    },
    "/template-index": {
        "title": "ຕະຫຼາດແບບ - ການແບບເວັບໄຊຕ໌ປະເພດສຳເລັດຂອງ Taoify",
        "desc": "ແບບເວັບໄຊຕ໌ປະເພດສຳເລັດສຳລັບໂຄງການໃດກໍ່ຕາມ, ການນຳໃຊ້ແບບຕົວເລືອກຫຼາຍຫຼິ້ນ, ການປະສົມປະສານຕາມຕົວເລືອກ."
    },
    "/question": {
        "title": "ສຳນັກງານຊ່ວຍເຫຼືອ · ຖ້າມີບັນຫາ, ປຶກສາທີ່ນີ້ກ່ອນ · Taoify",
        "desc": "ການເປີດຮ້ານ, ການປັບປຸງ, ການນຳເສັ້ນທາງ, ການນຳເງິນ, ການຕັ້ງລາຄາ, ການນຳເງິນ, ການຕັ້ງລຳດັບ, ການຕັ້ງລຳດັບ — ບັນຫາທີ່ເປັນທຸກໆເປັນທຸກໆຕາມປະເພດ, ຖ້າບໍ່ພົບ, ຕື່ມເພີ່ມການປະຕິບັດ."
    },
    "/about-us": {
        "title": "ກ່ຽວກັບ Taoify · ພວກເຮົາກຳລັງເຮັດຫຍັງ",
        "desc": "Taoify ແມ່ນATFORM ສ້າງເວ็บໄຊຕ໌ສໍາລັບຜູ້ຂາຍຕະຫຼາດ: ສ້າງເວ็บ, ເປັນພາສາ, ຕື່ມສິນຄ້າ, ລົງທະບຽນ, ການຈ່າຍເງິນ, ແລະການໂຄສະນາໃນບັນຫາດຽວ."
    },
    "/privacy-policy": {
        "title": "ກົດໝາຍຄວາມປອດໄພ · Taoify",
        "desc": "Taoify ຊີ້ນເຊື່ອມ, ສຳລັບ, ເກັບຮັກສາ, ແລະປຸງກັນຂໍ້ມູນສ່ວນຕົວຂອງທ່ານ, ແລະສິດທີ່ທ່ານມີໃນຂໍ້ມູນຂອງຕົນເອງ."
    },
    "/terms-service": {
        "title": "ກົດໝາຍບໍລິການ · Taoify",
        "desc": "ກົດໝາຍແລະເນື້ອໃນການໃຊ້ບ່ອນທີ່ການບໍລິການຂອງ Taoify: ຕັ້ງຄົນໃຊ້, ສາງຂາຍ, ການສັ່ງຊື້, ການຈ່າຍເງິນ ແລະ ການແບ່ງປັນຜົນຕຳຫຼວດ."
    },
    "/consumer-agreement": {
        "title": "ກົດໝາຍກັບເງິນ · Taoify",
        "desc": "ກົດໝາຍກັບເງິນແລະກົດໝາຍຫຼັງຈາກຂາຍສິນຄ້າໃນປະatform Taoify: ສຳນັກງານອານຸມັດ, ສະຖານະການກັບເງິນ, ແລະວິທີການຮັບເງິນ."
    },
    "/user-agreement": {
        "title": "ສັນຍາຜູ້ໃຊ້ · Taoify",
        "desc": "ກ່ອນຈະລົງທະບຽນແລະໃຊ້ Taoify ກະລຸນາອ່ານ: ປົກກະຕິການລົງທະບຽນ, ປົກກະຕິການປະຕິບັດຮ້ານຄ້າ, ແລະການອະນຸຍາດຂອງເວັບໄຊຕ໌."
    }
}
